module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Error {0} has occurred","text1":"You can go to the","text2":"main page"},"ru":{"title":"Произошла ошибка {0}","text1":"Вы можете перейти на","text2":"главную страницу"}}')
  delete Component.options._Ctor
}
